function ParallaxItems() {
	var self = this;
	self.init();
}

ParallaxItems.prototype.init = function() {
	var self = this;
	self.handleScrollParallax();
	self.handleMouseParallax();
	$(window).on('resize', this, this.handleScrollParallax.bind(self));
	$(window).on('resize', this, this.handleMouseParallax.bind(self));
};

ParallaxItems.prototype.handleMouseParallax = function() {
	var self = this;
	
	$('*[class*=ficon-]').each(function() {
		var that = this;
		if (typeof that.iconsParallax === 'undefined') {
			that.iconsParallax = new Parallax(that);
		}
		setTimeout(function() {
			if (app.mq == "medium" || app.mq == "small") {
				that.iconsParallax.scalar(-10 + 20*Math.random(), -10 + 20*Math.random());
			} else {
				that.iconsParallax.scalar(-15 + 30*Math.random(), -15 + 30*Math.random());
			}
		}, 500);
	});
	$('.shapes').each(function() {
		var that = this;
		if (typeof that.shapesParallax === 'undefined') {
			that.shapesParallax = new Parallax(that);
		}
		setTimeout(function() {
			if (app.mq == "small") {
				that.shapesParallax.scalar(100.0, 100.0);
			} else if (app.mq == "medium") {
				that.shapesParallax.scalar(0, 0);
			} else {
				that.shapesParallax.scalar(25.0, 25.0);
			}
		}, 500);
	});

	$('.text').each(function() {
		var that = this;
		if (typeof that.textParallax === 'undefined') {
			that.textParallax = new Parallax(that);
		}
		setTimeout(function() {
			if (app.mq == "medium" || app.mq == "small") {
				that.textParallax.scalar(60.0, 60.0);
			} else {
				that.textParallax.scalar(15.0, 15.0);
			}
		}, 500);
	});

	$('.guy').each(function() {
		var that = this;
		if (typeof that.guyParallax === 'undefined') {
			that.guyParallax = new Parallax(that);
		}
		setTimeout(function() {
			if (app.mq == "small") {
				that.guyParallax.scalar(80.0, 80.0);
			} else if (app.mq == "medium") {
				that.guyParallax.scalar(0, 0);
			} else {
				that.guyParallax.scalar(20.0, 20.0);
			}
		}, 500);
	});
};

ParallaxItems.prototype.handleScrollParallax = function() {
	var self = this;
	
	$('.shapes').each(function() {
		if (!$(this).closest('.swipe-items').length) {
			$(this).paroller({
				factorXl: -0.2,
				factorLg: -0.2,
				factorMd: 0,
				factorSm: 0, 
				factorXs: 0,
				type: 'foreground'
			});
		}
	});
	$('.text').each(function() {
		if (!$(this).closest('.swipe-items').length) {
			$(this).paroller({
				factorXl: -0.15,
				factorLg: -0.15,
				factorMd: 0,
				factorSm: 0, 
				factorXs: 0,
				type: 'foreground'
			});
		}
	});
	$('.guy').each(function() {
		if (!$(this).closest('.swipe-items').length) {
			$(this).paroller({
				factorXl: 0.25,
				factorLg: 0.25,
				factorMd: 0,
				factorSm: 0, 
				factorXs: 0,
				type: 'foreground'
			});
		}
	});
};